// Colour name -> swatch colour. Covers every colour in the admin list plus
// common saree / ethnic-wear names. Unknown names fall back to the CSS
// colour keyword, then to a neutral grey ring (never an empty dot).
const MAP = {
  black: '#1c1c1c', white: '#ffffff', offwhite: '#f4f0e6', ivory: '#f6f1e1', cream: '#f3e7c9', beige: '#e3d3b4',
  blue: '#1f4fbf', navyblue: '#1b2a5c', navy: '#1b2a5c', skyblue: '#7cc3ea', royalblue: '#2851c4', teal: '#0f7c7c',
  peacock: '#0a6f78', peacockblue: '#0a6f78', peacockgreen: '#0f6b55', turquoise: '#33c3c0', aqua: '#4fd1d9',
  grey: '#9a9a9a', gray: '#9a9a9a', darkgrey: '#555555', darkgray: '#555555', silver: '#c9c9c9', ash: '#b5b2ad',
  brown: '#7a4a2a', coffee: '#5b3a29', tan: '#c49a6c', copper: '#b06a3b', rust: '#a8461f',
  green: '#2f8f46', olive: '#6b7a2a', bottlegreen: '#0b4d32', mint: '#9fd8bf', parrotgreen: '#5bbf2a', lime: '#a9d23a',
  maroon: '#6e1423', wine: '#5e1b2d', red: '#d62b2b', rani: '#d6247e', ranipink: '#d6247e', pink: '#f08bb0',
  babypink: '#f6c4d4', peach: '#f6b99a', coral: '#f07862', magenta: '#c2187a', fuchsia: '#d63aa1',
  purple: '#6b2fa0', violet: '#7b3fb7', lavender: '#b9a3e3', lilac: '#c8a2c8', mauve: '#b784a7', onion: '#c98a9b',
  yellow: '#f2c418', mustard: '#d4a017', lemon: '#f4e04d', gold: '#c9a227', golden: '#c9a227',
  orange: '#f07c1f', saffron: '#f4991a', rose: '#e88ea3', rosegold: '#c98f7c'
};

export const colorKey = (name) => String(name || '').toLowerCase().replace(/[^a-z]/g, '');

// Returns a CSS background for a colour name
export const swatchBackground = (name) => {
  const key = colorKey(name);
  if (!key) return 'transparent';
  if (/multi|multicolou?r/.test(key)) {
    return 'conic-gradient(#d62b2b, #f2c418, #2f8f46, #1f4fbf, #6b2fa0, #d62b2b)';
  }
  if (MAP[key]) return MAP[key];
  // "Dark Green", "Light Pink" -> base colour
  const base = Object.keys(MAP).find((k) => key.endsWith(k));
  if (base) return MAP[base];
  return key; // let the browser try its own colour keyword
};
